function fn_comp_event_detail() {
    var $fn = $(".comp_event_detail, .comp_distributor_detail");

    if ($fn.length) {
        $fn.on("click","[data-gallery]",function(e) {
            e.preventDefault();

            var $this = $(this),
                $gallery_data = $this.data("gallery");

            $this.lightGallery({
                dynamic: true,
                thumbnails: true,
                counter: true,
                download: true,
                closable: true,
                dynamicEl: $gallery_data
            });
        });
    }
}